import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule, JsonpModule } from '@angular/http';
import { registerLocaleData } from '@angular/common';

import { CoreModule, AuthorizedGuard } from './core';
// import { CNgbModule } from './core/bootstrap.module';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule, NgbPaginationConfig, NgbAccordionConfig, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { TextMaskModule } from 'angular2-text-mask';
import { ROOT_ROUTES } from './app-routing.module';
import { Cookie, CookieBrowser, LocalStorage, LocalStorageBrowser, WindowModule } from './core';
import { DndModule } from 'ng2-dnd';

/// COMPONENTS
import { AppComponent } from './shared/components/app.component';
import { SmNavMenuFooterComponent } from './shared/components/sm-nav-menu-footer.component';
import { SmBackendLayoutComponent } from './shared/components/sm-backend-layout.component';
import { SmP404Component } from './shared/components/p404.component';
import { SmP500Component } from './shared/components/p500.component';
import { SmP0Component } from './shared/components/p0.component';

import { TransactionMenuSettingsResolver } from './shared/resolvers/transaction-menu-settings.resolver';
import { TransactionListSettingsResolver } from './shared/resolvers/transaction-list-settings.resolver';
import { TemplateListSettingsResolver } from './shared/resolvers/template-list-settings.resolver';
import { LeftMenuStateService } from './shared/services/left-menu-state.service';

import localeCs from '@angular/common/locales/cs';
registerLocaleData(localeCs);

const blru = (lru?: any) => lru || new Map();

@NgModule({
	bootstrap: [AppComponent],
	declarations: [
		AppComponent,
		SmNavMenuFooterComponent,
		SmBackendLayoutComponent,
		SmP404Component,
		SmP500Component,
		SmP0Component
	],
	imports: [
		// BrowserModule.withServerTransition({
		// 	appId: 'mp-universal'
		// }),
		BrowserModule,
		HttpModule,
		JsonpModule,
		FormsModule,
		BrowserAnimationsModule,
		WindowModule,
		ReactiveFormsModule,
		TextMaskModule,
		NgbModule.forRoot(),
		RouterModule.forRoot(ROOT_ROUTES),
		CoreModule.forRoot(),
		DndModule.forRoot(),
		SharedModule,
		SimpleNotificationsModule.forRoot(),
	],
	providers: [
		AuthorizedGuard,
		{ provide: Cookie, useClass: CookieBrowser },
		{ provide: LocalStorage, useClass: LocalStorageBrowser },
		{ provide: LOCALE_ID, useValue: 'cs-CS' },
		NgbPaginationConfig,
		NgbAccordionConfig,
		NgbDropdownConfig,
		{ provide: 'LRU', useFactory: blru, deps: [] },
		TransactionMenuSettingsResolver,
		TransactionListSettingsResolver,
		TemplateListSettingsResolver,
		LeftMenuStateService
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/app.module.ts